import React from "react";
import PropTypes from "prop-types";
import {
  CardContainer,
  CardImage,
  RecommendedBadge,
  ContentSection,
  Subtitle,
  Title,
  TagRow,
  TagButton,
} from "./InsightsCard.styles";

import { LineChartUpIcon, CoinsIcon, ClockIcon } from "assets/icons";

const InsightsCard = ({
  imageUrl,
  isRecommended,
  subtitle,
  title,
  tags,
  onTagClick,
}) => {
  // Investors and investment are optional so a caller can leave them off the card.
  const hasValue = (value) =>
    value !== undefined && value !== null && value !== "";
  const tagArray = [
    { label: tags.type, type: "type" },
    hasValue(tags.investors) && {
      label: `${tags.investors} Investors`,
      type: "investors",
      icon: ClockIcon,
    },
    hasValue(tags.investment) && {
      label: `${tags.investment} Investment`,
      type: "investment",
      icon: CoinsIcon,
    },
  ].filter(Boolean);

  return (
    <CardContainer>
      <CardImage src={imageUrl} alt={title} />
      {isRecommended && <RecommendedBadge>Recommended</RecommendedBadge>}
      <ContentSection>
        <div>
          {hasValue(subtitle) && <Subtitle>{subtitle}</Subtitle>}
          <Title>{title}</Title>
        </div>
        <TagRow>
          {tagArray.map((tag, index) => {
            let iconSrc = tag.icon
              ? tag.icon
              : tag.type === "type"
              ? LineChartUpIcon
              : null;

            return (
              <TagButton
                key={index}
                type={tag.type}
                onClick={() => onTagClick && onTagClick(tag)}
              >
                {iconSrc && (
                  <img src={iconSrc} alt={tag.type} width="12" height="12" />
                )}
                {tag.label}
              </TagButton>
            );
          })}
        </TagRow>
      </ContentSection>
    </CardContainer>
  );
};

InsightsCard.propTypes = {
  imageUrl: PropTypes.string,
  isRecommended: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  tags: PropTypes.shape({
    type: PropTypes.string,
    investors: PropTypes.string,
    investment: PropTypes.string,
  }),
  onTagClick: PropTypes.func,
};

export default InsightsCard;
